import { ITanglRemark } from '@/utils/TanglService/Interfaces/ITanglRemark';

export const parseRemarkMetadata = (remarkMetadata: string[]): ITanglRemark => {
    const result: Partial<ITanglRemark> = {};

    for (const entry of remarkMetadata) {
        const [key, value] = entry.split('=');
        try {
            (result as any)[key] = JSON.parse(value);
        } catch {
            (result as any)[key] = value;
        }
    }

    return result as ITanglRemark;
};
